/**
 * ELK options tuned for interactive Tidy on large campaigns.
 * - thoroughness 50 was very slow on big graphs; ELK defaults are often ~7–20.
 * - Large graphs: lower thoroughness + BRANDES_KOEPF placement (faster than NETWORK_SIMPLEX).
 * For maximum quality on small boards, thresholds keep NETWORK_SIMPLEX + higher thoroughness.
 *
 * Layout runs in a Web Worker when `public/elk-worker.min.js` is present (see `scripts/copy-elk-worker.js`).
 */
const ELK_LAYOUT_STATIC_OPTIONS = {
  'elk.algorithm': 'layered',
  'elk.direction': 'DOWN',
  'elk.edgeRouting': 'ORTHOGONAL',
  'elk.layered.crossingMinimization.strategy': 'LAYER_SWEEP',
  'elk.layered.nodePlacement.favorStraightEdges': 'true',
  'elk.spacing.nodeNode': '40',
  'elk.layered.spacing.nodeNodeBetweenLayers': '60',
  'elk.spacing.edgeEdge': '16',
  'elk.spacing.edgeNode': '16',
  'elk.layered.spacing.edgeEdgeBetweenLayers': '16',
  'elk.portConstraints': 'FIXED_SIDE',
  'elk.layered.mergeEdges': 'false',
  'elk.layered.compaction.postCompaction.strategy': 'EDGE_LENGTH',
};

export function buildRootLayoutOptions(nodeCount, edgeCount) {
  const large = nodeCount >= 70 || edgeCount >= 100;
  const huge = nodeCount >= 140 || edgeCount >= 220;

  let thoroughness = '22';
  let placement = 'NETWORK_SIMPLEX';
  if (huge) {
    thoroughness = '5';
    placement = 'BRANDES_KOEPF';
  } else if (large) {
    thoroughness = '10';
    placement = 'BRANDES_KOEPF';
  }

  return {
    ...ELK_LAYOUT_STATIC_OPTIONS,
    'elk.layered.thoroughness': thoroughness,
    'elk.layered.nodePlacement.strategy': placement,
  };
}
